import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var CONTEXT_KEY_RE = /^\.\/(light|dark)\/(.+)\.(.+)$/;

function parseContextKey(key) {
  var match = key.match(CONTEXT_KEY_RE);

  if (match) {
    var _match = _slicedToArray(match, 4),
        theme = _match[1],
        name = _match[2],
        ext = _match[3];

    return {
      theme: theme,
      name: name,
      ext: ext
    };
  }

  return null;
}

export function importContext(context) {
  var store = {};

  if (context) {
    context.keys().forEach(function (key) {
      var keyData = parseContextKey(key);

      if (!keyData) {
        return;
      }

      var module = context(key);
      store[keyData.theme] = store[keyData.theme] || {};
      store[keyData.theme][keyData.name] = module["default"] || module;
    });
  }

  return store;
}
export function isContext(context) {
  return typeof context === 'function' && typeof context.keys === 'function' && typeof context.resolve === 'function';
}
// #sourceMappingURL=context.js.map